import useApiQuery from 'shared/hooks/use-api-query';
import {CompanyProps} from 'modules/companies/types';
import citiesKeys from '../util/cities-keys';

const useCityCompanyBillings = (cityId: string) => {
  return useApiQuery<CompanyProps[]>({
    url: `/cities/${cityId}/billing-recorency`,
    queryKey: citiesKeys.billingRecorency(cityId),
  });
};

export default useCityCompanyBillings;
